




































import { Component, Mixins, Prop } from "vue-property-decorator";
import { FormatSet } from "../../../../../domain/format";
import { IEditTreeRootSource, ITreeRootSource } from "../sources";
import { DialogMixin } from "../../../../system/mixins";
import FormatSetTreeEditView from "./FormatSetTreeEditView.vue";
import { RootDirectory } from "../../../../../domain/drawing";

@Component({
  components: {
    FormatSetTreeEditView,
  }
})
export default class FormatSetTreeEditDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      result: false,
      shouldIgnoreChained: false,
      rootDirectory: null as RootDirectory<string, FormatSet>,
    };
  }
  result: boolean;
  shouldIgnoreChained: boolean;
  rootDirectory: RootDirectory<string, FormatSet>;

  $refs!: {
    formatSetTreeEditor: FormatSetTreeEditView,
  };

  @Prop()
  treeSource: ITreeRootSource<FormatSet> & IEditTreeRootSource<FormatSet>;

  get isLoaded(): boolean {
    return !!this.rootDirectory;
  }

  async show(shouldIgnoreChained: boolean): Promise<boolean> {
    this.shouldIgnoreChained = shouldIgnoreChained;
    this.rootDirectory = null;
    return this.showModal(async () => {
      this.rootDirectory = await this.treeSource.getTreeRoot();
      this.result = false;
      await this.waitHidden();
      this.rootDirectory = null;
      this.$refs.formatSetTreeEditor.clear();
      return !!this.result;
    });
  }

  async save(): Promise<void> {
    if (!this.isVisible) { return; }
    await this.$refs.formatSetTreeEditor.save();
    await this.$nextTick();
    this.result = true;
    this.isVisible = false;
  }

  cancelEdit(): void {
    this.result = false;
    this.isVisible = false;
  }
}
